export const getUrlParam = (key: string): string | null =>
  typeof URLSearchParams === 'undefined' || typeof location === 'undefined'
    ? null
    : new URLSearchParams(location.search).get(key);
